export class UserCreds {
    email: string;
    userId: string;
    password: string;
}